import { render, staticRenderFns } from "./PollView.vue?vue&type=template&id=55fe99e6"
import script from "./PollView.vue?vue&type=script&lang=js"
export * from "./PollView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports